
import Vue from 'vue';
import { namespace } from 'vuex-class';
import { Component, Prop } from 'vue-property-decorator';

import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { getOverviewUrlBySport } from '@/routing/sports';

import { sportAliases } from '@/enums/sports';

import type { SportLocale } from '@/enums/sports';
import { ObjectType, SportType } from '@/@types/graphql-types';

const Language = namespace('language');

@Component({ name: 'SportCard' })
export default class SportCard extends Vue {
	@Prop({ required: true }) sport: SportType;

	@Language.State webLocale: SportLocale;

	get sportIcon() {
		return `/${ASSETS_DIR}/img/sports/icons/sport/${this.sport.toLowerCase()}.png`;
	}

	get name() {
		return this.$tc(`SPORTS_WEBAPP_SPORT_TYPE_${this.sport}`);
	}

	get fullPath() {
		return getOverviewUrlBySport(this.sport, this.webLocale as SportLocale);
	}

	get showSportCard() {
		return sportAliases[this.sport][this.webLocale];
	}

	handleSportClick() {
		const sportContext = new SnowplowSportContext(this.sport, ObjectType.Sport);

		TrackingHelper.trackEvent(
			'userinteraction',
			{ action: 'sport_clicked', property: 'icon', useLastRoute: true },
			[sportContext]
		);
	}
}
